const menus = [
    {
        id: 1,
        name: 'INICIO',
        links: '/',
    },
    {
        id: 2,
        name: 'NOSOTROS',
        links: '/about',
    },
    {
        id: 3,
        name: 'SOLUCIONES',
        links: '#',
        namesub: [
            { id: 1, sub: 'E-LEARNING', links: '/e-learning' },
            { id: 2, sub: 'SIMULADORES', links: '/simulators' },
            { id: 3, sub: 'CAPACITACIONES', links: '/training' },
            { id: 4, sub: 'APLICACIONES DE GESTIÓN HSE', links: '/hse-management' }
        ]
    },
    {
        id: 4,
        name: 'BLOG',
        links: '/blog',
    },
    {
        id: 5,
        name: 'TRAYECTORIA',
        links: '/trajectory',
    },
    {
        id: 6,
        name: 'CONTACTO',
        links: '/contact',
    }
]

export default menus;